<template>
  <div class="slot-form">
    <h3>Slot Hinzufügen</h3>
    <input class="slot-form__input" type="date" v-model="date" />
    <button class="slot-form__button" @click="addSlot(date)">Hinzufügen</button>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      date: " "
    };
  },
  methods: {
    ...mapActions(["addSlot"])
  }
};
</script>

<style>
.slot-form {
  border-top: 1px solid;
}
.slot-form__input,
.slot-form__button {
  font-size: inherit;
  background-color: #eeffee;
  line-height: inherit;
  letter-spacing: inherit;
  font-family: inherit;
  border: 0;
  padding: 0;
  cursor: pointer;
  transition: opacity 0.2s 0.5s;
  margin-right: 0.2em;
}
.slot-form__button:hover {
  background-color: #99ff99;
}
.slot-form__input {
  background-color: #eee;
}
.slot-form__input:focus,
.slot-form__input:hover {
  background-color: #fff;
}
/* .slot-form:hover .slot-form__input,
.slot-form:hover .slot-form__button {
  transition: opacity 0.2s 0s;
  opacity: 1;
} */
</style>
